// Multivariate Dependencies
import React, { Suspense } from 'react';
// Components
import { Skeleton } from '../Skeleton/Skeleton';
/**
 * @deprecated Do not use legacy components anymore.
 */
export var SuspenseWrapper = function (_a) {
    var children = _a.children, _b = _a.fallback, fallback = _b === void 0 ? React.createElement(Skeleton, null) : _b;
    return React.createElement(Suspense, { fallback: fallback }, children);
};
//# sourceMappingURL=SuspenseWrapper.js.map